import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = {
  class: "listDiv content",
  style: {"width":"600px"}
}
const _hoisted_2 = { class: "listDivRightList" }
const _hoisted_3 = { class: "checkboxDiv" }
const _hoisted_4 = { class: "listDivRight" }
const _hoisted_5 = { class: "addDiv content" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = { class: "color-list" }
const _hoisted_8 = {
  class: "color-item",
  style: {"cursor":"default"}
}
const _hoisted_9 = { class: "color-item2 color-itemList drag" }
const _hoisted_10 = { class: "nameInfo" }
const _hoisted_11 = { class: "dialog-footer" }

import _ from 'lodash'
import { DragOutlined, CloseOutlined } from '@ant-design/icons-vue';
import draggable from "vuedraggable";
import { ref, getCurrentInstance} from 'vue';
import { message } from 'ant-design-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomColumn',
  props: {
  resetColumn: {
    type: Array
  },
  storageName: {
    type: String,
    required: true,
  }
},
  emits: ['cancel', 'ok'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { proxy } = getCurrentInstance();
const emits = __emit

const showDia = ref(false)

// 左侧展示的全部列
const leftColumnData = ref([])
// 右侧上方固定列
const fixedList = ref([])
// 右侧下方已经选择的列
const draggableList = ref([])

const props = __props;

const checkAll = ref(false);
const isIndeterminate = ref(false);
const checkedValue = ref([]);
const hasAction = ref(false)
const actionObj = ref(null)

function show() {
  showDia.value = true
  initColumns()
}

function initColumns() {

  let origin = _.cloneDeep(props.resetColumn)

  hasAction.value = origin.findIndex(v=>v.key=='action') > -1
  console.log('hasAction.value', hasAction.value)
  origin = origin.filter(v=>v.key!='action')
    
  console.log('origin', origin)
  let selected = []

  let savedColumns = localStorage.getItem(props.storageName) || null

  console.log('savedColumns', savedColumns)
  if (savedColumns) {
    // 有保存的column
    savedColumns = JSON.parse(savedColumns)
    leftColumnData.value = origin.map(val=>{
      val['isChoosed'] = savedColumns.includes(val.key)
      return val
    })
    savedColumns.forEach(val=>{
      let obj = leftColumnData.value.find(v=>v.key==val)
      if (obj) selected.push(obj)
    })
    // selected = leftColumnData.value.filter(v=>v.isChoosed)
  } else {
    leftColumnData.value = origin.map(v=>({...v,isChoosed: true,}))
    selected = leftColumnData.value
  }

  draggableList.value =  selected.filter(v=>!v.isFixed).filter(Boolean)

  fixedList.value = leftColumnData.value.filter(v=>v.isFixed)

  checkedValue.value = leftColumnData.value.filter(v=>v.isChoosed).map(v=>v.key)

  checkAll.value = checkedValue.value.length == leftColumnData.value.length
  
  isIndeterminate.value = !checkAll.value

}

const handleCheckAllChange = (val) => {
  isIndeterminate.value = !checkAll.value
  if (checkAll.value) { // 全选
    leftColumnData.value = leftColumnData.value.map(v=>({...v,isChoosed: true,}))
    checkedValue.value = leftColumnData.value.map(v=>v.key)


    draggableList.value = leftColumnData.value.filter(v=>!v.isFixed)
    
  } else { // 全不选
    leftColumnData.value = leftColumnData.value.map(v=>({...v,isChoosed: v.isFixed}))
    checkedValue.value = leftColumnData.value.filter(v=>v.isFixed).map(v=>v.key)
    
    
    draggableList.value = []
  }
}

function handleCheckedChange(el, item) {
  if (el.target.checked) {
    draggableList.value.push(item)
  } else {
    let index = draggableList.value.findIndex(v=>v.key==item.key)
    draggableList.value.splice(index, 1)
  }
}
async function onSubmit() {
  let saved = draggableList.value.map(v=>v.key)
  let fixed = fixedList.value.map(v=>v.key)
  let fields = fixed.concat(saved)
  console.log('保存', fields)
  if (hasAction.value) {
    fields.push('action')
    console.log('保存1', fields)
  }
  localStorage.setItem(props.storageName, JSON.stringify(fields))
  message.success('设置成功！')
  onCancle()
}

function resetConfig() {
  localStorage.setItem(props.storageName, '')
  initColumns()
}

const onCancle = () => {
  showDia.value = false
  emits("ok")
}

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    open: showDia.value,
    "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((showDia).value = $event)),
    title: "设置自定义列",
    width: "870px"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_a_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showDia.value = false))
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode("取 消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: onSubmit
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode("应 用", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "header" }, "可添加列", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "labelTitle" }, "配置列", -1)),
                _createVNode(_component_a_checkbox, {
                  checked: checkAll.value,
                  "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((checkAll).value = $event)),
                  indeterminate: isIndeterminate.value,
                  onChange: handleCheckAllChange
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("全选", -1)
                  ]))]),
                  _: 1
                }, 8, ["checked", "indeterminate"]),
                _createVNode(_component_a_checkbox_group, {
                  value: checkedValue.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((checkedValue).value = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leftColumnData.value, (columnItem, index) => {
                      return (_openBlock(), _createBlock(_component_a_checkbox, {
                        onChange: ($event: any) => (handleCheckedChange($event, columnItem)),
                        key: index,
                        value: columnItem.key,
                        disabled: columnItem.isFixed,
                        style: {"width":"32%"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(columnItem.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["onChange", "value", "disabled"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(" 已选 " + _toDisplayString(checkedValue.value.length) + " / " + _toDisplayString(leftColumnData.value.length) + " 项 ", 1),
            _createElementVNode("span", {
              class: "clear",
              onClick: resetConfig
            }, "重置")
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fixedList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1)
              ]))
            }), 128)),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "divider" }, [
              _createElementVNode("span", null, "以上是固定项")
            ], -1)),
            _createElementVNode("div", null, [
              _createVNode(_unref(draggable), {
                list: draggableList.value,
                "item-key": "prop",
                tag: "ul",
                handle: ".drag",
                "append-to-body": ""
              }, {
                item: _withCtx(({ element, index }) => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(DragOutlined), { style: {"color":"#333"} }),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(element.title), 1),
                      _createVNode(_unref(CloseOutlined), {
                        style: {"color":"rgb(51, 51, 51)"},
                        onClick: ($event: any) => (_ctx.deleteSingleColumn(element, index))
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["list"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})